// src/views/Dashboard.js
import React, { useState, useEffect } from 'react';
import { dashboardAPI } from '../api/api';

function Dashboard() {
  const [stats, setStats] = useState({
    totalQuestions: 0,
    publishedQuestions: 0
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDashboardStats = async () => {
      try {
        const data = await dashboardAPI.getStats();
        setStats(data);
      } catch (err) {
        setError(err.message);
        console.error('Erreur lors de la récupération des statistiques du tableau de bord:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardStats();
  }, []);

  if (loading) {
    return (
      <div className="px-4 py-6 sm:px-0">
        <div className="bg-white shadow rounded-lg p-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Tableau de bord</h2>
          <div className="flex justify-center items-center h-32">
            <p className="text-gray-600">Chargement des données...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="px-4 py-6 sm:px-0">
        <div className="bg-white shadow rounded-lg p-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Tableau de bord</h2>
          <div className="bg-red-50 border border-red-200 rounded-lg p-6">
            <p className="text-red-600">Erreur: {error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="px-4 py-6 sm:px-0">
      <div className="bg-white shadow rounded-lg p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Tableau de bord</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-blue-50 rounded-lg p-6">
            <h3 className="text-lg font-medium text-blue-800">Total des questions</h3>
            <p className="text-3xl font-bold text-blue-600 mt-2">{stats.totalQuestions}</p>
          </div>
          <div className="bg-green-50 rounded-lg p-6">
            <h3 className="text-lg font-medium text-green-800">Questions publiées</h3>
            <p className="text-3xl font-bold text-green-600 mt-2">{stats.publishedQuestions}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;